import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be82904"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "summary-form p-mt-5 p-mx-2"
}
const _hoisted_2 = { class: "p-d-flex border-bottom p-p-3 summary-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" หมายเลขการติดตามผล : "),
  /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "RET20200401")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("สถานะ: "),
  /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "รอการพิจารณา")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-body p-px-3 p-py-5 p-text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("div", null, " ขอบคุณสำหรับการติดต่อเรา ขณะนี้รายการคืนสินค้าของคุณได้รับกรบันทึกเข้าสู่ระบบ กรุณารอการติดต่อกลับ 1-3 วันทำการ ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "p-mt-5 f-size-14" }, [
    /*#__PURE__*/_createElementVNode("div", null, " หากท่านต้องการแจ้งปัญหาเพิ่มเติม ท่านสามารถติดต่อ พนักงานขายของท่าน หรือติดต่อส่วนกลางผ่านช่องทางดังนี้ "),
    /*#__PURE__*/_createElementVNode("div", null, "Line: xxx")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnRepuestForm = _resolveComponent("ReturnRepuestForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.sumaryState == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", null, [
                _createElementVNode("u", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSummaryState(2)))
                }, "ดูรายละเอียด")
              ])
            ])
          ]),
          _hoisted_7
        ]))
      : (_openBlock(), _createBlock(_component_ReturnRepuestForm, {
          key: 1,
          isDisplay: true
        }))
  ]))
}